import { render, staticRenderFns } from "./NhapLieu.vue?vue&type=template&id=713bb703&scoped=true"
import script from "./NhapLieu.vue?vue&type=script&lang=ts"
export * from "./NhapLieu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713bb703",
  null
  
)

export default component.exports